import React, { FunctionComponent } from "react";
import { Typography } from "@material-ui/core";
import "./index.scss";
import { Link } from "../../config/components";
import { Variant as ThemeVariant } from "@material-ui/core/styles/createTypography";
import { Space } from "../../services/entities/spaces";

type Variant = ThemeVariant | "srOnly";

interface BackgroundAssetPosition {
  top?: string | any;
  right?: string | any;
  bottom?: string | any;
  left?: string | any;
}

type PanelChooseProps = {
  title?: string | any;
  text?: string | any;
  code?: string | any;
  backgroundAsset?: string;
  backgroundAssetPosition?: BackgroundAssetPosition;
  backgroundAssetSize?: string;
  index?: number;
  imageLeft?: boolean;
  sectionTitle?: string | any;
  highlightedText?: string | any;
  link?: Link | undefined;
  titleVariant?: Variant | "inherit";
  sectionPadding?: string | any;
  space: Space;
  value?: number;
  i?: number;
  key: string;
};

type SpaceStatProps = {
  unit: string;
  metric: string;
};

export const PanelChoose: FunctionComponent<PanelChooseProps> = ({
  title,
  text,
  code,
  backgroundAsset,
  backgroundAssetPosition = {
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
  },
  backgroundAssetSize,
  index,
  sectionTitle,
  highlightedText,
  link,
  titleVariant = "h1",
  sectionPadding,
  space,
  value,
  i,
}) => {
  return (
    // <TabPanel value={value} i={i}>
    <section
      className={`tab-panel tab-panel-${index} panel-choose ${sectionPadding}`}
    >
      {sectionTitle && (
        <Typography
          variant={titleVariant}
          component="h2"
          className="section-title"
        >
          {sectionTitle}
        </Typography>
      )}

      {title && (
        <Typography
          variant="subtitle1"
          component="h2"
          className="title"
          dangerouslySetInnerHTML={{
            __html: title.toString(),
          }}
        />
      )}

      {text && (
        <Typography
          variant="body1"
          component="div"
          className="text"
          dangerouslySetInnerHTML={{
            __html: text.toString(),
          }}
        />
      )}
      {/* {link && (
        <Button className="link" variant="outlined" href={link.url}>
          {link.label}
        </Button>
      )} */}
    </section>
    // </TabPanel>
  );
};

export default PanelChoose;
